import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./../AuthProvider";

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});